import Vue from 'vue'
import VuetifyMoney from '@/components/VuetifyMoney.vue'

Vue.component('vuetify-money', VuetifyMoney)

export default VuetifyMoney
